import { css } from "./SKT";
import { SKTBaseComponent } from "./SKTBaseComponent";

export const SKTRadioOption = ({ id, value, label, isChecked, onChange }) => {
  return (
    <label className={css("radio-inline")}>
      <input
        type="radio"
        name={id}
        value={value}
        className={css("data data-cb")}
        checked={isChecked}
        onClick={onChange}
      />
      {label}
    </label>
  );
};

export const SKTRadioButton = ({
  id,
  data,
  label,
  children,
  singleValue,
  defaultValue,
}) => {
  const childValues = children.map((child) => child.props.value);
  const onChange = (selectedValue) => {
    return () => {
      if (singleValue) {
        data.set(id, selectedValue);
        return;
      }
      data.setMany(
        childValues.reduce((prev, childValue) => {
          const result = { ...prev };
          result[id + childValue] = selectedValue === childValue;
          return result;
        }, {})
      );
    };
  };

  const isChildChecked = (value) => {
    if (singleValue) {
      const dataValue = data.get(id) ?? defaultValue;
      return dataValue === value;
    }
    return data.get(id + value);
  };

  return (
    <SKTBaseComponent data={data} id={id} label={label} childrenToLeft={true}>
      {children.map((child) => {
        const value = child.props.value;
        child.props.id = id;
        child.props.onChange = onChange(value);
        child.props.isChecked = isChildChecked(value);
        return child;
      })}
    </SKTBaseComponent>
  );
};
